import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ControlResumidoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }


  // OJO QUE ES USADO DESDE 2 VISTAS DIFERENTES MODAL-CONTROL-EFECTIVO Y LIQUIDACION-CONTROL-EFECTIVO
  validarControlResume(inputParams: {
    entidad: {
      pagos: {
        empresa_rut: number
        sucursal_codigo: number
        // forma_pago: {
        //   tipo_pago_codigo: number
        //   empresa_rut: number
        //   tipo_cuenta_bancaria_codigo: number
        //   banco_codigo: number
        //   numero_cuenta: string
        //   fecha_pago: Date
        //   monto: number,
        //   sucursal_codigo: number,
        //   numero_doc: number,
        //   tipo_pago_nombre: string
        // }[],
        forma_pago: any[] | null,
        diferencial_pago: number | any
        difereciaPago?: any[]
        monto_coforme?: number
      }[]
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracionDTOInputType) {
          control_resumido {
            validarControlResume(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                efectivo_recaudado
                cantidad_transferencias
                monto_deposito
                monto_cheque
                diferencia_monto
                total_pagoacuenta
                total_resumen
                listaDepositos {
                  numero_deposito
                  monto
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  banco_nombre
                  numero_cuenta
                  fecha_deposito
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.control_resumido.validarControlResume
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerControlResumenSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: control_resumidoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          control_resumido {
            obtenerControlResumenSegunFiltro(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  fecha_registro
                  efectivo_recaudado
                }
              }
            }
          }
        }
        
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.control_resumido.obtenerControlResumenSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerControlResumenTotalEfectivo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: control_resumidoInputType) {
          control_resumido {
            obtenerControlResumenTotalEfectivo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                total_resumen
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.control_resumido.obtenerControlResumenTotalEfectivo
        callback({ mensajes, respuesta })
      }
    );
  }

}
